const initialState = { permittedRoutes: 'BLAAA', isDataAvailable: false };

export const routes = {
    namespaced: true,
    state: initialState,
    actions: {
        setPermittedRoutes({ commit }, routesData) {
            commit('routesSuccess', routesData);
        },
    },
    mutations: {
        routesSuccess(state, routesData) {
            state.isDataAvailable = true;
            state.permittedRoutes = routesData;
        },
    },
    getters: {
        getPermittedRoutesGetter: state => {
            return state.permittedRoutes;
        }
    }
};
